var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 1024a510.64 510.64 0 01-395.06-186.32 42.67 42.67 0 0165.81-54.32A425.59 425.59 0 00512 938.64c235.26 0 426.67-191.39 426.67-426.64S747.26 85.36 512 85.36 85.33 276.75 85.33 512A42.67 42.67 0 110 512C0 229.7 229.68 0 512 0s512 229.67 512 512-229.68 512-512 512zm269.3-412.26a46.55 46.55 0 00-46.55-46.55H525.3V279.27a46.55 46.55 0 00-93.09 0v332.47a46.55 46.55 0 0046.54 46.55h256a46.55 46.55 0 0046.55-46.55z"
  })));
}
export default SvgHistory;